<script setup lang="ts">
const store = useSongStore();
const catalogs = computed(() => store.data?.catalogs);

const shown = computed(() => {
  if (
    store.status === LoadStatus.Ready &&
    store.song?.products.general.authorized &&
    !store.song?.catalogs?.length
  ) {
    return false;
  }
  return true;
});
</script>

<template>
  <section v-if="shown">
    <SectionTitle :placeholder="store.placeholderNotLoaded">{{
      $t("G.LIT_Catalogs")
    }}</SectionTitle>
    <div
      v-if="store.placeholderNotAuthorized"
      :class="{ 'placeholder-glow': store.loading }"
    >
      <Placeholder
        :min-width="145"
        :max-width="250"
      />
    </div>
    <div v-else>
      <div
        v-for="(c, i) of catalogs"
        :key="i"
      >
        <router-link
          :to="`/search/results?${c.searchQuery}`"
          class="link text-primary"
          >{{ c.label }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
